import Layout from '@/components/layout/index.vue'

export default {
  path: 'barcode',
  name: 'Barcode',
  meta: {},
  component: Layout,
  redirect: { name: 'Barcode.Barfactor' },
  children: [
    {
      path: 'barfactor',
      name: 'Barcode.Barfactor',
      meta: {},
      component: () => import('@/views/setting/barcode/barfactor/index.ts')
    },
    {
      path: 'barfactor/add',
      name: 'Barcode.Barfactor.Add',
      meta: { title: 'common.add', dep: 'Barcode.Barfactor' },
      component: () => import('@/views/setting/barcode/barfactor/add.ts')
    },
    {
      path: 'barfactor/modify/:id',
      name: 'Barcode.Barfactor.Modify',
      meta: { title: 'common.modify', dep: 'Barcode.Barfactor' },
      component: () => import('@/views/setting/barcode/barfactor/modify.ts')
    },
    {
      path: 'barpara',
      name: 'Barcode.Barpara',
      meta: {},
      component: () => import('@/views/setting/barcode/barpara/index.ts')
    },
    {
      path: 'barpara/add',
      name: 'Barcode.Barpara.Add',
      meta: { title: 'common.add', dep: 'Barcode.Barpara' },
      component: () => import('@/views/setting/barcode/barpara/add.ts')
    },
    {
      path: 'barpara/modify/:id',
      name: 'Barcode.Barpara.Modify',
      meta: { title: 'common.modify', dep: 'Barcode.Barpara' },
      component: () => import('@/views/setting/barcode/barpara/modify.ts')
    },
    {
      path: 'rule',
      name: 'Barcode.Rule',
      meta: {},
      component: () => import('@/views/setting/barcode/rule/index.ts')
    },
    {
      path: 'rule/add',
      name: 'Barcode.Rule.Add',
      meta: { title: 'common.add', dep: 'Barcode.Rule' },
      component: () => import('@/views/setting/barcode/rule/add.ts')
    },
    {
      path: 'rule/modify/:barRuleNo/:id',
      name: 'Barcode.Rule.Modify',
      meta: { title: 'common.modify', dep: 'Barcode.Rule' },
      component: () => import('@/views/setting/barcode/rule/modify.ts')
    }
  ]
}
